import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "container-fluid p-4" };
const _hoisted_2 = {
    key: 0,
    class: "alert alert-success d-flex align-items-center gap-2"
};
const _hoisted_3 = {
    key: 1,
    class: "alert alert-danger d-flex align-items-center gap-2"
};
const _hoisted_4 = { class: "card border-0 shadow-sm mb-3" };
const _hoisted_5 = { class: "card-body" };
const _hoisted_6 = { class: "row g-3" };
const _hoisted_7 = { class: "col-md-4" };
const _hoisted_8 = { class: "col-md-4" };
const _hoisted_9 = ["value"];
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { class: "col-md-4" };
const _hoisted_12 = ["value"];
const _hoisted_13 = { class: "card border-0 shadow-sm" };
const _hoisted_14 = { class: "card-body" };
const _hoisted_15 = { class: "table-responsive" };
const _hoisted_16 = { class: "table table-hover align-middle" };
const _hoisted_17 = { key: 0 };
const _hoisted_18 = { key: 1 };
const _hoisted_19 = { class: "text-muted small" };
const _hoisted_20 = { class: "text-muted small" };
const _hoisted_21 = { class: "text-center" };
const _hoisted_22 = ["disabled", "onClick"];
const _hoisted_23 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-1"
};
const _hoisted_24 = {
    key: 1,
    class: "fas fa-trash"
};
const _hoisted_25 = {
    key: 0,
    class: "card-footer bg-white border-top mt-3"
};
const _hoisted_26 = { class: "d-flex flex-column flex-md-row justify-content-between align-items-center gap-2" };
const _hoisted_27 = { class: "text-muted" };
const _hoisted_28 = { class: "pagination pagination-sm mb-0" };
const _hoisted_29 = ["onClick"];
const _hoisted_30 = { class: "page-link" };
const _hoisted_31 = {
    key: 2,
    class: "modal fade show d-block",
    style: { "background-color": "rgba(0,0,0,0.18)" }
};
const _hoisted_32 = { class: "modal-dialog" };
const _hoisted_33 = { class: "modal-content" };
const _hoisted_34 = { class: "modal-header" };
const _hoisted_35 = ["disabled"];
const _hoisted_36 = {
    key: 0,
    class: "progress",
    style: { "height": "4px" }
};
const _hoisted_37 = { class: "modal-body" };
const _hoisted_38 = { class: "mb-3" };
const _hoisted_39 = ["value"];
const _hoisted_40 = { key: 0 };
const _hoisted_41 = { class: "mb-3" };
const _hoisted_42 = ["value"];
const _hoisted_43 = { class: "modal-footer" };
const _hoisted_44 = ["disabled"];
const _hoisted_45 = ["disabled"];
const _hoisted_46 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_47 = { key: 1 };
const _hoisted_48 = { key: 2 };
import { computed, onMounted, reactive, ref } from 'vue';
import adminLocationSubcategoriesService from '@/services/admin/location-subcategories.admin.service';
import adminLocationsService from '@/services/admin/locations.admin.service';
import adminSubcategoriesService from '@/services/admin/subcategories.admin.service';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AdminLocationSubcategories',
    setup(__props) {
        const links = ref([]);
        const loading = ref(false);
        const search = ref('');
        const filterLocation = ref('');
        const filterSubcategory = ref('');
        const pagination = reactive({ limit: 10, offset: 0 });
        const locationOptions = ref([]);
        const subcategoryOptions = ref([]);
        const showForm = ref(false);
        const formLoading = ref(false);
        const form = reactive({ location_id: '', subcategory_id: '' });
        const successMessage = ref('');
        const errorMessage = ref('');
        const removingRelationId = ref('');
        const filtered = computed(() => {
            const searchTerm = search.value.toLowerCase().trim();
            return links.value.filter(link => {
                let match = true;
                if (searchTerm) {
                    match = Boolean((link.location_name && link.location_name.toLowerCase().includes(searchTerm)) ||
                        (link.subcategory_name && link.subcategory_name.toLowerCase().includes(searchTerm)));
                }
                if (match && filterLocation.value) {
                    match = String(link.location_id) === String(filterLocation.value);
                }
                if (match && filterSubcategory.value) {
                    match = String(link.subcategory_id) === String(filterSubcategory.value);
                }
                return match;
            });
        });
        const totalPages = computed(() => Math.max(1, Math.ceil(filtered.value.length / pagination.limit)));
        const currentPage = computed(() => Math.floor(pagination.offset / pagination.limit) + 1);
        const pages = computed(() => {
            const total = totalPages.value;
            const current = currentPage.value;
            const start = Math.max(1, current - 2);
            const end = Math.min(total, current + 2);
            const all = [];
            for (let p = start; p <= end; p++)
                all.push(p);
            return all;
        });
        const paginated = computed(() => filtered.value.slice(pagination.offset, pagination.offset + pagination.limit));
        function setPage(page) {
            const safe = Math.min(Math.max(1, page), totalPages.value);
            pagination.offset = (safe - 1) * pagination.limit;
        }
        function openForm() {
            form.location_id = '';
            form.subcategory_id = '';
            showForm.value = true;
        }
        function closeForm() {
            if (!formLoading.value) {
                showForm.value = false;
            }
        }
        async function loadOptions() {
            try {
                const [locationsRes, subcategoriesRes] = await Promise.all([
                    adminLocationsService.list({ limit: 9999 }),
                    adminSubcategoriesService.list()
                ]);
                if (locationsRes && Array.isArray(locationsRes.data)) {
                    locationOptions.value = locationsRes.data.map(loc => ({
                        id: loc.id,
                        name: loc.name,
                        type: loc.type || (loc.department?.name ?? '')
                    }));
                }
                if (subcategoriesRes && Array.isArray(subcategoriesRes.data)) {
                    subcategoryOptions.value = subcategoriesRes.data.map(sub => ({
                        id: sub.id,
                        name: sub.name
                    }));
                }
            }
            catch (error) {
                console.error('Error cargando opciones', error);
            }
        }
        async function reload() {
            loading.value = true;
            errorMessage.value = '';
            try {
                const res = await adminLocationSubcategoriesService.list();
                if (res && res.success && Array.isArray(res.data)) {
                    links.value = res.data;
                }
                else if (res && Array.isArray(res.data)) {
                    links.value = res.data;
                }
                else if (Array.isArray(res)) {
                    links.value = res;
                }
                else {
                    links.value = [];
                }
            }
            catch (error) {
                errorMessage.value = error?.response?.data?.message || error?.message || 'No se pudo cargar la lista';
                links.value = [];
                console.error('Error al cargar locaciones & subcategorías', error);
            }
            finally {
                loading.value = false;
            }
        }
        async function saveRelation() {
            if (!form.location_id) {
                errorMessage.value = 'Debes seleccionar una locación';
                return;
            }
            if (!form.subcategory_id) {
                errorMessage.value = 'Debes seleccionar una subcategoría';
                return;
            }
            formLoading.value = true;
            errorMessage.value = '';
            try {
                await adminLocationSubcategoriesService.create({
                    location_id: Number(form.location_id),
                    subcategory_id: Number(form.subcategory_id)
                });
                successMessage.value = 'Relación guardada correctamente';
                setTimeout(() => {
                    successMessage.value = '';
                }, 4000);
                showForm.value = false;
                await reload();
            }
            catch (error) {
                errorMessage.value = error?.response?.data?.message || error?.message || 'No se pudo guardar la relación';
            }
            finally {
                formLoading.value = false;
            }
        }
        async function removeRelation(link) {
            const identifier = `${link.location_id}-${link.subcategory_id}`;
            if (!confirm('¿Eliminar esta relación?'))
                return;
            removingRelationId.value = identifier;
            try {
                await adminLocationSubcategoriesService.remove(link.location_id, link.subcategory_id);
                await reload();
            }
            catch (error) {
                alert('No se pudo eliminar la relación: ' + (error?.response?.data?.message || error?.message));
            }
            finally {
                removingRelationId.value = '';
            }
        }
        onMounted(async () => {
            await Promise.all([loadOptions(), reload()]);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2" }, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", null, [
                        _createElementVNode("h1", { class: "h3 mb-1" }, [
                            _createElementVNode("i", { class: "fas fa-sitemap text-primary me-2" }),
                            _createTextVNode(" Locaciones & Subcategorías ")
                        ]),
                        _createElementVNode("p", { class: "text-muted mb-0" }, "Gestiona qué subcategorías están asociadas a cada locación")
                    ], -1)),
                    _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: openForm
                    }, [...(_cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "fas fa-plus me-2" }, null, -1),
                            _createTextVNode(" Nueva relación ", -1)
                        ]))])
                ]),
                (successMessage.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-check-circle" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(successMessage.value), 1)
                    ]))
                    : _createCommentVNode("", true),
                (errorMessage.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(errorMessage.value), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-control",
                                    placeholder: "Buscar por locación o subcategoría...",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((search).value = $event))
                                }, null, 512), [
                                    [_vModelText, search.value]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _withDirectives(_createElementVNode("select", {
                                    class: "form-select",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((filterLocation).value = $event))
                                }, [
                                    _cache[13] || (_cache[13] = _createElementVNode("option", { value: "" }, "Todas las locaciones", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationOptions.value, (loc) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: loc.id,
                                            value: String(loc.id)
                                        }, [
                                            _createTextVNode(_toDisplayString(loc.name) + " ", 1),
                                            (loc.type)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "(" + _toDisplayString(loc.type) + ")", 1))
                                                : _createCommentVNode("", true)
                                        ], 8, _hoisted_9));
                                    }), 128))
                                ], 512), [
                                    [_vModelSelect, filterLocation.value]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _withDirectives(_createElementVNode("select", {
                                    class: "form-select",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((filterSubcategory).value = $event))
                                }, [
                                    _cache[14] || (_cache[14] = _createElementVNode("option", { value: "" }, "Todas las subcategorías", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subcategoryOptions.value, (sub) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: sub.id,
                                            value: String(sub.id)
                                        }, _toDisplayString(sub.name), 9, _hoisted_12));
                                    }), 128))
                                ], 512), [
                                    [_vModelSelect, filterSubcategory.value]
                                ])
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("table", _hoisted_16, [
                                _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", null, "Locación"),
                                        _createElementVNode("th", null, "Subcategoría"),
                                        _createElementVNode("th", {
                                            class: "text-center",
                                            style: { "width": "140px" }
                                        }, "Acciones")
                                    ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                    (loading.value)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [...(_cache[15] || (_cache[15] = [
                                                _createElementVNode("td", {
                                                    colspan: "3",
                                                    class: "text-center p-4"
                                                }, [
                                                    _createElementVNode("span", { class: "spinner-border spinner-border-sm text-primary" }),
                                                    _createElementVNode("span", { class: "ms-2" }, "Cargando relaciones…")
                                                ], -1)
                                            ]))]))
                                        : (paginated.value.length === 0)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [...(_cache[16] || (_cache[16] = [
                                                    _createElementVNode("td", {
                                                        colspan: "3",
                                                        class: "text-center p-4 text-muted"
                                                    }, [
                                                        _createElementVNode("i", { class: "fas fa-folder-open fa-2x d-block mb-2" }),
                                                        _createTextVNode(" No hay resultados con los filtros actuales ")
                                                    ], -1)
                                                ]))]))
                                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(paginated.value, (link) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: link.id || `${link.location_id}-${link.subcategory_id}`
                                                }, [
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("strong", null, _toDisplayString(link.location_name || 'Locación sin nombre'), 1),
                                                        _createElementVNode("div", _hoisted_19, "ID: " + _toDisplayString(link.location_id), 1)
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("strong", null, _toDisplayString(link.subcategory_name || 'Subcategoría sin nombre'), 1),
                                                        _createElementVNode("div", _hoisted_20, "ID: " + _toDisplayString(link.subcategory_id), 1)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_21, [
                                                        _createElementVNode("button", {
                                                            class: "btn btn-sm btn-outline-danger",
                                                            disabled: !link.id && removingRelationId.value === `${link.location_id}-${link.subcategory_id}`,
                                                            onClick: ($event) => (removeRelation(link))
                                                        }, [
                                                            (removingRelationId.value === (link.id ? String(link.id) : `${link.location_id}-${link.subcategory_id}`))
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_23))
                                                                : (_openBlock(), _createElementBlock("i", _hoisted_24)),
                                                            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "ms-1" }, "Eliminar", -1))
                                                        ], 8, _hoisted_22)
                                                    ])
                                                ]));
                                            }), 128))
                                ])
                            ])
                        ]),
                        (totalPages.value > 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("small", _hoisted_27, " Mostrando " + _toDisplayString(filtered.value.length ? (pagination.offset + 1) : 0) + "–" + _toDisplayString(Math.min(pagination.offset + pagination.limit, filtered.value.length)) + " de " + _toDisplayString(filtered.value.length) + " relaciones ", 1),
                                    _createElementVNode("nav", null, [
                                        _createElementVNode("ul", _hoisted_28, [
                                            _createElementVNode("li", {
                                                class: _normalizeClass(["page-item", { disabled: currentPage.value <= 1 }]),
                                                onClick: _cache[3] || (_cache[3] = ($event) => (setPage(1)))
                                            }, [...(_cache[19] || (_cache[19] = [
                                                    _createElementVNode("span", { class: "page-link" }, "Primera", -1)
                                                ]))], 2),
                                            _createElementVNode("li", {
                                                class: _normalizeClass(["page-item", { disabled: currentPage.value <= 1 }]),
                                                onClick: _cache[4] || (_cache[4] = ($event) => (setPage(currentPage.value - 1)))
                                            }, [...(_cache[20] || (_cache[20] = [
                                                    _createElementVNode("span", { class: "page-link" }, "«", -1)
                                                ]))], 2),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (p) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    class: _normalizeClass(["page-item", { active: currentPage.value === p }]),
                                                    key: p,
                                                    onClick: ($event) => (setPage(p))
                                                }, [
                                                    _createElementVNode("span", _hoisted_30, _toDisplayString(p), 1)
                                                ], 10, _hoisted_29));
                                            }), 128)),
                                            _createElementVNode("li", {
                                                class: _normalizeClass(["page-item", { disabled: currentPage.value >= totalPages.value }]),
                                                onClick: _cache[5] || (_cache[5] = ($event) => (setPage(currentPage.value + 1)))
                                            }, [...(_cache[21] || (_cache[21] = [
                                                    _createElementVNode("span", { class: "page-link" }, "»", -1)
                                                ]))], 2),
                                            _createElementVNode("li", {
                                                class: _normalizeClass(["page-item", { disabled: currentPage.value >= totalPages.value }]),
                                                onClick: _cache[6] || (_cache[6] = ($event) => (setPage(totalPages.value)))
                                            }, [...(_cache[22] || (_cache[22] = [
                                                    _createElementVNode("span", { class: "page-link" }, "Última", -1)
                                                ]))], 2)
                                        ])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                (showForm.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                    _cache[23] || (_cache[23] = _createElementVNode("h4", { class: "modal-title" }, "Nueva relación", -1)),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        onClick: closeForm,
                                        disabled: formLoading.value
                                    }, null, 8, _hoisted_35)
                                ]),
                                (formLoading.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [...(_cache[24] || (_cache[24] = [
                                            _createElementVNode("div", {
                                                class: "progress-bar progress-bar-striped progress-bar-animated bg-primary",
                                                style: { "width": "100%" }
                                            }, null, -1)
                                        ]))]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("div", _hoisted_38, [
                                        _cache[26] || (_cache[26] = _createElementVNode("label", { class: "form-label" }, [
                                            _createTextVNode("Locación "),
                                            _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _withDirectives(_createElementVNode("select", {
                                            class: "form-select",
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((form.location_id) = $event))
                                        }, [
                                            _cache[25] || (_cache[25] = _createElementVNode("option", { value: "" }, "Selecciona una locación", -1)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationOptions.value, (loc) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: loc.id,
                                                    value: String(loc.id)
                                                }, [
                                                    _createTextVNode(_toDisplayString(loc.name) + " ", 1),
                                                    (loc.type)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, "(" + _toDisplayString(loc.type) + ")", 1))
                                                        : _createCommentVNode("", true)
                                                ], 8, _hoisted_39));
                                            }), 128))
                                        ], 512), [
                                            [_vModelSelect, form.location_id]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_41, [
                                        _cache[28] || (_cache[28] = _createElementVNode("label", { class: "form-label" }, [
                                            _createTextVNode("Subcategoría "),
                                            _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _withDirectives(_createElementVNode("select", {
                                            class: "form-select",
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((form.subcategory_id) = $event))
                                        }, [
                                            _cache[27] || (_cache[27] = _createElementVNode("option", { value: "" }, "Selecciona una subcategoría", -1)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subcategoryOptions.value, (sub) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: sub.id,
                                                    value: String(sub.id)
                                                }, _toDisplayString(sub.name), 9, _hoisted_42));
                                            }), 128))
                                        ], 512), [
                                            [_vModelSelect, form.subcategory_id]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("button", {
                                        class: "btn btn-secondary",
                                        onClick: closeForm,
                                        disabled: formLoading.value
                                    }, "Cancelar", 8, _hoisted_44),
                                    _createElementVNode("button", {
                                        class: "btn btn-primary",
                                        onClick: saveRelation,
                                        disabled: formLoading.value
                                    }, [
                                        (formLoading.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_46))
                                            : _createCommentVNode("", true),
                                        (formLoading.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_47, "Guardando…"))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_48, "Guardar relación"))
                                    ], 8, _hoisted_45)
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
